export default "__VITE_ASSET__DukQjp9m__"